export const userSpecifics = userObj => {
  const currentUser = userObj.current || {};
  const parentOrg = (userObj.orgBranches || []).find(org => org.value === currentUser.parentOrganizationId);
  const isOnBranch = currentUser.branchId !== undefined && currentUser.branchId !== parentOrg?._id;
  const parent = (userObj.current || {}).parent === true;

  return { isOnBranch, parent };
};
